module.exports = __webpack_public_path__ + "static/media/srinivas.6495514a.jpg";